import {
    getAllCargoTemperatureConfigsItems,
    getAllCargoTemperatureLogItems,
    deleteCargoTemperatureConfigsItem,
    deleteCargoTemperatureLogItem,
} from 'src/api/cargo-temp-log/offlineCargoTempLogApi';
import useSyncHelper from './useSyncHelper';
import { useSWService } from 'src/api/sw/useSWService';

const useSyncOfflineCargoTempLog = () => {
    const { syncItems } = useSyncHelper();
    const { refreshRequestsContaining } = useSWService();

    const syncCargoTemperatureConfigsItems = async () =>
        await syncItems(
            getAllCargoTemperatureConfigsItems,
            deleteCargoTemperatureConfigsItem,
            ['saveCargoTemperatureConfigsRequest', 'deleteCargoTemperatureConfigsRequest'],
            'saveCargoTemperatureConfigsId'
        );

    const syncCargoTemperatureLogItems = async () =>
        await syncItems(getAllCargoTemperatureLogItems, deleteCargoTemperatureLogItem, ['saveCargoTemperatureLogRequest'], 'logDate');

    const syncOfflineCargoTempLog = async (skipRefresh?: boolean | null) => {
        await syncCargoTemperatureConfigsItems();
        await syncCargoTemperatureLogItems();

        if (!skipRefresh) {
            await refreshRequestsContaining(['GetCargoTemperatureConfigs', 'GetCargoTempLogDates', 'GetCargoTemperatureLog']);
        }
    };

    return {
        syncOfflineCargoTempLog,
    };
};

export default useSyncOfflineCargoTempLog;
